module.exports = __webpack_public_path__ + "img/2-center.3a4e053b.png";